import buildItemComponent from "../../common/item-component-hoc"

import SourceViewItemContainer from "./view/SourceViewItemContainer"
import SourceViewFormActionButtonsWidgetContainer from "./view/SourceViewFormActionButtonsWidgetContainer"
import SourceEditItemContainer from "./edit/SourceEditItemContainer"
import SourceEditFormActionButtonsWidgetContainer from "./edit/SourceEditFormActionButtonsWidgetContainer"

const Source = buildItemComponent("sources", {
    view: [SourceViewFormActionButtonsWidgetContainer, SourceViewItemContainer],
    edit: [SourceEditFormActionButtonsWidgetContainer, SourceEditItemContainer]
})

export default Source
